export default {
  setListings(state, payload) {
    state.listings = payload.listings
  },
  setPage(state, payload) {
    state.config.page = payload.page
  },
  setTotal(state, payload) {
    state.config.total = payload.total
  },
  setOnSale(state, payload) {
    state.onSale = payload
  },
  setAveragePrice(state, payload) {
    state.averagePrice = payload
  },
  setSortBy(state, payload) {
    state.sortBy = payload.sortBy
  },
  toggleLoading(state) {
    state.loading = !state.loading
  }
}
